import {
  IBoardCaseAttachmentModel,
  IBoardCaseDetailModel,
} from '../../models/BoardCase'

export interface SystemState {
  boardmeetings: {
    case: {
      data: IBoardCaseDetailModel | null
      loading: boolean
      error: string

      caseAttachments: {
        data: IBoardCaseAttachmentModel[] | null
        error: string | null
        loading: boolean
        // Used to send files when creating a new case
        temporaryStorage: File[] | null
        tookTooLong: boolean
      }

      hasConflict: boolean
      processing: unknown // todo: CaseProccessingStateEnum did not exist.
      processingId: string | null
    }
  }
}

export const getBoardCase = (state: SystemState) => state.boardmeetings.case

export const getCaseAttachments = (state: SystemState) => {
  const boardCase = getBoardCase(state)
  return boardCase.caseAttachments
}
